const config = (window as any).__RUNTIME_CONFIG__ || {};

export const CONST: { [key: string]: string } = {
  serviceVersion: "1.020",
  // Cognito（テナント固有）
  userPoolId: config.COGNITO_USER_POOL_ID || "",
  userPoolClientId: config.COGNITO_CLIENT_ID || "",
  // REST API（環境共通パス）
  apiUrl: (config.API_BASE_URL || "") + "/accessDB/",
  apiUrl2: (config.API_BASE_URL || "") + "/accessDB2/",
  apiCognitoUrl: (config.API_BASE_URL || "") + "/accessCognito/",
  // WebSocket（WEBSOCKET_ENV_PREFIX-{suffix}パターン）
  inputCSVWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-input-csv`,
  inputCSVContractStatusWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-input-csv-contract-status`,
  inputCSVPaymentWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-input-csv-payment`,
  outputXLSXPaymentsWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-output-xlsx-payment`,
  outputXLSXContractsWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-output-xlsx-contract`,
  outputXLSXTossUpsWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-output-xlsx-toss-up`,
  outputXLSXFollowCallsWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-output-xlsx-follow-call`,
  aiChatSupportWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-ai-chat`,
  aiChatAnalysisWebSocketAPIURL: `${config.WEBSOCKET_BASE_URL || ""}/${config.WEBSOCKET_ENV_PREFIX || ""}-ai-data-chat`,
  webSocketRegion: "ap-northeast-1",
  tableBackgroundColor: "rgb(230, 230, 240)",
  tableDetailsBackgroundColor: "rgb(210, 210, 230)",
  /** ダッシュボード: トスアップのサブカラム初期値 */
  dashboard_tossup_sub_count_initial: "クロージング-開通数",
  /** ダッシュボード: クロージングのサブカラム初期値 */
  dashboard_closing_sub_count_initial: "クロージング-開通数",
};

export const LIST: { [key: string]: string[] } = {
  display_mode: ["日別", "月別"],
  authority: [
    "",
    "マスターアカウント",
    "スタッフアカウント",
    "パートナー",
    "営業MGR",
    "営業アカウント",
    "トスアップアカウント",
  ],
  price_type: ["", "ショット", "ストック"],
  payment_period: [
    "",
    "開通日の翌月末",
    "開通日の翌々月末",
    "開通日の3ヶ月後末",
    "開通日の20日締め翌月末",
  ],
  payment_state: [
    "",
    "正常",
    "正常以外",
    "上位店支払明細の取込なし",
    "申込日から上位店入金単価を検索できません",
    "支払方法、申込日、リストIDからパートナー支払単価を検索できません",
    "上位店明細と商材単価の入金額不一致",
    "売上金額がマイナス",
    "上位店支払明細の取込はあるが、エントリー情報なし",
    "パートナーへの支払のみのはずが、上位店支払明細の取込があり",
  ],
  payment_company_status: [
    "",
    "通常",
    "パートナーへの支払のみ",
    "上位店の入金のみ",
    "パートナーへの戻入のみ",
    "上位店の戻入のみ",
  ],
  sns_type: [
    "",
    "ChatWorkでエントリー情報送信",
    "LINEでエントリー情報送信",
    "社内ChatWorkにエントリー情報通知",
  ],
  cancell_sns_type: [
    "",
    "ChatWorkでエントリー情報送信",
    "LINEでエントリー情報送信",
    "社内ChatWorkにエントリー情報通知",
  ],
  service_type: [
    "",
    "プラン",
    "コンテンツ",
    "キャンペーン（プルダウン）",
    "キャンペーン（チェックボックス）",
  ],
  login_status: ["", "正常", "ログイン不可能"],
  trading_type: ["", "通常", "独自単価", "戻入"],
  back_payment_time: [
    "",
    "開通日の月末までに解約",
    "開通日の1か月後月末までに解約",
    "開通日の2か月後月末までに解約",
    "開通日の3か月後月末までに解約",
    "開通日の4か月後月末までに解約",
    "開通日の5か月後月末までに解約",
    "開通日の6か月後月末までに解約",
    "開通日の7か月後月末までに解約",
    "開通日の8か月後月末までに解約",
    "開通日の9か月後月末までに解約",
    "開通日の10か月後月末までに解約",
    "開通日の11か月後月末までに解約",
    "開通日の12か月後月末までに解約",
  ],
  payment_check_record_flg: ["", "ON", "OFF"],
  customer_list_id_flg: [
    "",
    "使用しない",
    "グループ1",
    "グループ2",
    "グループ3",
    "グループ4",
    "グループ5",
    "グループ6",
    "グループ7",
    "グループ8",
    "グループ9",
    "グループ10",
  ],
  product_key: ["", "申込番号", "顧客電話番号"],
  product_contract_number: ["", "自動付与", "上位店が付与"],
  cancell_action: ["", "手動解約不可", "手動解約可能"],
  no_entry_flg: ["", "通常", "停止中"],
  site_status: ["", "通常", "閉鎖中", "商材停止中"],
  contract_deactivation: ["", "エントリー取消"],
  toss_up_deactivation: ["", "トスアップ取消"],
  incentive_status_conf: ["", "ステータスを指定しない", "ステータスを指定する"],
  follow_call_entry_status_conf: [
    "",
    "ステータスを指定しない",
    "ステータスを指定する",
  ],
  follow_call_base_day_conf: ["", "システム登録日", "申込日", "開通日"],
  analysys_granularity: ["日別", "月別"],
  entry_analysys_division_admin: [
    "商材",
    "パートナー",
    "グループ",
    "営業アカウント",
    "社内担当者",
  ],
  entry_analysys_division_partner: ["商材", "グループ", "営業アカウント"],
  entry_analysys_count_type: ["システム登録日", "申込日", "開通日", "解約日"],
  entry_analysys_sub_count: ["クロージング件数"],
  entry_analysys_price_type: ["ショット", "ストック"],
  entry_analysys_display: [
    "エントリー数(ショット)",
    "エントリー数(ストック)",
    "開通数(ショット)",
    "開通数(ストック)",
    "解約数",
  ],
  toss_up_analysys_division_admin: [
    "トスアップパートナー",
    "トスアップグループ",
    "トスアップ担当者",
    "クロージングパートナー",
    "クロージンググループ",
    "クロージング担当者",
    "クロージング商材",
  ],
  toss_up_analysys_division_partner: [
    "トスアップグループ",
    "トスアップ担当者",
    "クロージンググループ",
    "クロージング担当者",
  ],
  /** パートナー・営業MGR用（トスアップ日時の表示区分） */
  toss_up_analysys_division_partner_toss_up: [
    "トスアップグループ",
    "トスアップ担当者",
  ],
  /** トスアップアカウント用（トスアップ担当者のみ選択可） */
  toss_up_analysys_division_partner_toss_up_account: ["トスアップ担当者"],
  toss_up_analysys_division_admin_tossup: [
    "トスアップパートナー",
    "トスアップグループ",
    "トスアップ担当者",
  ],
  toss_up_analysys_division_admin_closing: [
    "クロージングパートナー",
    "クロージンググループ",
    "クロージング担当者",
  ],
  toss_up_analysys_division_partner_closing: [
    "クロージンググループ",
    "クロージング担当者",
  ],
  toss_up_analysys_count_type: ["トスアップ日", "クロージング日"],
  toss_up_analysys_count_type_toss_up: ["トスアップ日"],
  toss_up_analysys_count_type_closing: ["クロージング日"],
  /** 集計項目（トスアップ・クロージング分析用・全リスト） */
  toss_up_aggregation_item: [
    "トスアップ数",
    "トスアップ-有効アポ数",
    "トスアップ-前確OK数",
    "トスアップ-開通数",
    "クロージング-有効アポ数",
    "クロージング-エントリー数",
    "クロージング-開通数",
    "クロージング-成功",
    "クロージング-失敗",
    "トスアップ、不出、時節、見込み、架電中",
    "対象外、条件期間外、長期不出",
  ],
  /** 集計項目（トスアップ分析用） */
  toss_up_aggregation_item_tossup: [
    "トスアップ数",
    "トスアップ-有効アポ数",
    "トスアップ-前確OK数",
    "トスアップ-開通数",
  ],
  /** 集計項目（クロージング分析用） */
  toss_up_aggregation_item_closing: [
    "クロージング-有効アポ数",
    "クロージング-エントリー数",
    "クロージング-開通数",
  ],
  /** サブカラム（トスアップ・クロージング分析用・全リスト） */
  toss_up_analysys_sub_count: [
    "クロージング-有効アポ数",
    "クロージング-エントリー数",
    "クロージング-開通数",
  ],
  /** サブカラム（トスアップ分析用。「なし」＋集計項目） */
  toss_up_analysys_sub_count_tossup: [
    "クロージング-有効アポ数",
    "クロージング-エントリー数",
    "クロージング-開通数",
  ],
  /** サブカラム（クロージング分析用。「なし」＋集計項目） */
  toss_up_analysys_sub_count_closing: ["クロージング-開通数"],
  /** 集計項目（エントリー分析モーダル用・表示用） */
  entry_aggregation_item: ["エントリー数", "開通数", "解約数"],
  toss_up_analysys_status: [
    "",
    "トスアップ、不出、時節、見込み、架電中",
    "クロージング-成功",
    "クロージング-失敗",
    "対象外、条件期間外、長期不出",
  ],
  hope_call_time_kind: ["", "最短", "時間指定", "いつでも"],
  hope_call_time_hour: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
  ],
  hope_call_time_minute: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ],
  toss_up_status: [
    "",
    "トスアップ",
    "クロージング-成功",
    "クロージング-成功（未エントリー）",
    "クロージング-成功（他社）",
    "クロージング-失敗",
    "不出",
    "時節",
    "見込み",
    "対象外",
    "条件期間外",
    "長期不出",
    "架電中",
  ],
  follow_call_status: [
    "",
    "フォローコールを行わない",
    "フォローコール未実施",
    "フォローコール完了",
    "不出",
    "時節",
  ],
  advance_payment_high_rank_company: [
    "",
    "サービスの支払い開始時期に従う",
    "開通日の月末に入金",
    "開通日の1か月後末に入金",
    "開通日の2か月後末に入金",
    "開通日の3か月後末に入金",
    "開通日の4か月後末に入金",
    "開通日の5か月後末に入金",
    "開通日の6か月後末に入金",
    "開通日の7か月後末に入金",
    "開通日の8か月後末に入金",
    "開通日の9か月後末に入金",
    "開通日の10か月後末に入金",
    "開通日の11か月後末に入金",
    "開通日の12か月後末に入金",
  ],
  advance_payment_sale_company: [
    "",
    "サービスの支払い開始時期に従う",
    "開通日の月末に振込",
    "開通日の1か月後末に振込",
    "開通日の2か月後末に振込",
    "開通日の3か月後末に振込",
    "開通日の4か月後末に振込",
    "開通日の5か月後末に振込",
    "開通日の6か月後末に振込",
    "開通日の7か月後末に振込",
    "開通日の8か月後末に振込",
    "開通日の9か月後末に振込",
    "開通日の10か月後末に振込",
    "開通日の11か月後末に振込",
    "開通日の12か月後末に振込",
  ],
  advance_back_payment_sale_company: [
    "",
    "解約日の月末に請求",
    "解約日の1か月後末に請求",
    "解約日の2か月後末に請求",
    "解約日の3か月後末に請求",
    "解約日の4か月後末に請求",
    "解約日の5か月後末に請求",
    "解約日の6か月後末に請求",
  ],
  advance_back_payment_high_rank_company: [
    "",
    "解約日の月末に請求",
    "解約日の1か月後末に請求",
    "解約日の2か月後末に請求",
    "解約日の3か月後末に請求",
    "解約日の4か月後末に請求",
    "解約日の5か月後末に請求",
    "解約日の6か月後末に請求",
  ],
  outside_payment_company: ["", "ロボットペイメント", "SBペイメント"],
  outside_payment_method: [
    "",
    "クレジットカード",
    "ソフトバンクまとめて支払い",
    "auかんたん決済",
  ],
  screen_name: ["", "トスアップ管理", "エントリー管理"],
  screen_column_auth: ["", "表示制限なし", "マスター・スタッフアカウントのみ"],
  screen_column_system_default: ["", "独自項目", "デフォルト項目"],
  screen_column_type: [
    "",
    "フリー記入",
    "プルダウン",
    "チェックボックス",
    "日付",
  ],
};

export const LIST_POST: { [key: string]: { id: number; value: string }[] } = {
  authority: [
    {
      id: 0,
      value: "マスターアカウント",
    },
    {
      id: 1,
      value: "スタッフアカウント",
    },
    {
      id: 2,
      value: "パートナー",
    },
    {
      id: 3,
      value: "営業MGR",
    },
    {
      id: 4,
      value: "営業アカウント",
    },
    {
      id: 5,
      value: "トスアップアカウント",
    },
  ],
  partner_authority: [
    {
      id: 2,
      value: "パートナー",
    },
    {
      id: 3,
      value: "営業MGR",
    },
    {
      id: 4,
      value: "営業アカウント",
    },
    {
      id: 5,
      value: "トスアップアカウント",
    },
  ],
  edit_authority: [
    {
      id: 3,
      value: "営業MGR",
    },
    {
      id: 4,
      value: "営業アカウント",
    },
    {
      id: 5,
      value: "トスアップアカウント",
    },
  ],
  price_type: [
    {
      id: 0,
      value: "ショット",
    },
    {
      id: 1,
      value: "ストック",
    },
  ],
  payment_period: [
    {
      id: 0,
      value: "開通日の翌月末",
    },
    {
      id: 1,
      value: "開通日の翌々月末",
    },
    {
      id: 2,
      value: "開通日の3ヶ月後末",
    },
    {
      id: 3,
      value: "開通日の20日締め翌月末",
    },
  ],
  sns_send: [
    {
      id: 0,
      value: "連携しない",
    },
    {
      id: 1,
      value: "連携する",
    },
  ],
  sns_send_flg: [
    {
      id: 0,
      value: "連携しない",
    },
    {
      id: 1,
      value: "連携する",
    },
  ],
  option_type: [
    {
      id: 0,
      value: "フリー記入",
    },
    {
      id: 1,
      value: "プルダウン",
    },
    {
      id: 2,
      value: "チェックボックス",
    },
    {
      id: 3,
      value: "日付",
    },
    {
      id: 4,
      value: "画像",
    },
  ],
  change_value_conf: [
    {
      id: 0,
      value: "通常",
    },
    {
      id: 1,
      value: "編集不可",
    },
  ],
  toss_up_option_flg: [
    {
      id: 0,
      value: "なし",
    },
    {
      id: 1,
      value: "電話番号フラグ",
    },
    {
      id: 2,
      value: "氏名フラグ",
    },
    {
      id: 6,
      value: "メールアドレスフラグ",
    },
    {
      id: 3,
      value: "郵便番号フラグ",
    },
    {
      id: 4,
      value: "住所フラグ",
    },
    {
      id: 5,
      value: "半角スペース必須フラグ",
    },
    {
      id: 7,
      value: "フォーム用電話番号フラグ",
    },
    {
      id: 8,
      value: "複数行フラグ",
    },
    {
      id: 11,
      value: "半角数字フラグ",
    },
  ],
  contract_option_flg: [
    {
      id: 0,
      value: "なし",
    },
    {
      id: 1,
      value: "電話番号フラグ",
    },
    {
      id: 2,
      value: "氏名フラグ",
    },
    {
      id: 9,
      value: "社名フラグ",
    },
    {
      id: 6,
      value: "メールアドレスフラグ",
    },
    {
      id: 3,
      value: "郵便番号フラグ",
    },
    {
      id: 4,
      value: "住所フラグ",
    },
    {
      id: 5,
      value: "半角スペース必須フラグ",
    },
    {
      id: 7,
      value: "フォーム用電話番号フラグ",
    },
    {
      id: 8,
      value: "複数行フラグ",
    },
    {
      id: 11,
      value: "半角数字フラグ",
    },
  ],
  entry_form_option_flg: [
    {
      id: 0,
      value: "なし",
    },
    {
      id: 1,
      value: "電話番号フラグ",
    },
    {
      id: 2,
      value: "氏名フラグ",
    },
    {
      id: 9,
      value: "社名フラグ",
    },
    {
      id: 6,
      value: "メールアドレスフラグ",
    },
    {
      id: 3,
      value: "郵便番号フラグ",
    },
    {
      id: 4,
      value: "住所フラグ",
    },
    {
      id: 5,
      value: "半角スペース必須フラグ",
    },
    {
      id: 7,
      value: "フォーム用電話番号フラグ",
    },
    {
      id: 8,
      value: "複数行フラグ",
    },
    {
      id: 10,
      value: "申込番号フラグ",
    },
    {
      id: 11,
      value: "半角数字フラグ",
    },
  ],
  sns_type: [
    {
      id: 0,
      value: "ChatWorkでエントリー情報送信",
    },
    {
      id: 1,
      value: "LINEでエントリー情報送信",
    },
    {
      id: 2,
      value: "社内ChatWorkにエントリー情報通知",
    },
  ],
  cancell_sns_type: [
    {
      id: 0,
      value: "ChatWorkでエントリー情報送信",
    },
    {
      id: 1,
      value: "LINEでエントリー情報送信",
    },
    {
      id: 2,
      value: "社内ChatWorkにエントリー情報通知",
    },
  ],
  sns_toss_up_account_info: [
    {
      id: 0,
      value: "アカウント情報を送付しない",
    },
    {
      id: 1,
      value: "アカウント情報を送付する",
    },
  ],
  service_type: [
    {
      id: 0,
      value: "プラン",
    },
    {
      id: 1,
      value: "コンテンツ",
    },
    {
      id: 2,
      value: "キャンペーン（プルダウン）",
    },
    {
      id: 3,
      value: "キャンペーン（チェックボックス）",
    },
  ],
  login_status: [
    {
      id: 0,
      value: "正常",
    },
    {
      id: 1,
      value: "ログイン不可能",
    },
  ],
  trading_type: [
    {
      id: 0,
      value: "通常",
    },
    {
      id: 1,
      value: "独自単価",
    },
    {
      id: 2,
      value: "戻入",
    },
  ],
  trading_type_high_rank: [
    {
      id: 0,
      value: "通常",
    },
    {
      id: 2,
      value: "戻入",
    },
  ],
  product_key: [
    {
      id: 0,
      value: "申込番号",
    },
    {
      id: 1,
      value: "顧客電話番号",
    },
  ],
  product_contract_number: [
    {
      id: 0,
      value: "自動付与",
    },
    {
      id: 1,
      value: "上位店が付与",
    },
  ],
  cancell_action: [
    {
      id: 3,
      value: "手動解約不可",
    },
    {
      id: 0,
      value: "手動解約可能",
    },
  ],
  incentive_status_conf: [
    {
      id: 0,
      value: "ステータスを指定しない",
    },
    {
      id: 1,
      value: "ステータスを指定する",
    },
  ],
  follow_call_entry_status_conf: [
    {
      id: 0,
      value: "ステータスを指定しない",
    },
    {
      id: 1,
      value: "ステータスを指定する",
    },
  ],
  follow_call_base_day_conf: [
    {
      id: 0,
      value: "システム登録日",
    },
    {
      id: 1,
      value: "申込日",
    },
    {
      id: 2,
      value: "開通日",
    },
  ],
  follow_call_day_offset: [
    {
      id: 1,
      value: "基準日の１日後",
    },
    {
      id: 2,
      value: "基準日の２日後",
    },
    {
      id: 3,
      value: "基準日の３日後",
    },
    {
      id: 4,
      value: "基準日の４日後",
    },
    {
      id: 5,
      value: "基準日の５日後",
    },
    {
      id: 6,
      value: "基準日の６日後",
    },
    {
      id: 7,
      value: "基準日の７日後",
    },
    {
      id: 10,
      value: "基準日の１０日後",
    },
    {
      id: 15,
      value: "基準日の１５日後",
    },
    {
      id: 30,
      value: "基準日の３０日後",
    },
  ],
  follow_call_day_offset_open: [
    {
      id: -30,
      value: "基準日の３０日前",
    },
    {
      id: -15,
      value: "基準日の１５日前",
    },
    {
      id: -10,
      value: "基準日の１０日前",
    },
    {
      id: -7,
      value: "基準日の７日前",
    },
    {
      id: -6,
      value: "基準日の６日前",
    },
    {
      id: -5,
      value: "基準日の５日前",
    },
    {
      id: -4,
      value: "基準日の４日前",
    },
    {
      id: -3,
      value: "基準日の３日前",
    },
    {
      id: -2,
      value: "基準日の２日前",
    },
    {
      id: -1,
      value: "基準日の１日前",
    },
    {
      id: 0,
      value: "基準日当日",
    },
    {
      id: 1,
      value: "基準日の１日後",
    },
    {
      id: 2,
      value: "基準日の２日後",
    },
    {
      id: 3,
      value: "基準日の３日後",
    },
    {
      id: 4,
      value: "基準日の４日後",
    },
    {
      id: 5,
      value: "基準日の５日後",
    },
    {
      id: 6,
      value: "基準日の６日後",
    },
    {
      id: 7,
      value: "基準日の７日後",
    },
    {
      id: 10,
      value: "基準日の１０日後",
    },
    {
      id: 15,
      value: "基準日の１５日後",
    },
    {
      id: 30,
      value: "基準日の３０日後",
    },
  ],
  hope_call_time_kind: [
    {
      id: 0,
      value: "最短",
    },
    {
      id: 1,
      value: "時間指定",
    },
    {
      id: 2,
      value: "いつでも",
    },
  ],
  toss_up_status: [
    {
      id: 0,
      value: "トスアップ",
    },
    {
      id: 1,
      value: "クロージング-成功",
    },
    {
      id: 7,
      value: "クロージング-成功（未エントリー）",
    },
    {
      id: 10,
      value: "クロージング-成功（他社）",
    },
    {
      id: 2,
      value: "クロージング-失敗",
    },
    {
      id: 3,
      value: "不出",
    },
    {
      id: 4,
      value: "時節",
    },
    {
      id: 5,
      value: "見込み",
    },
    {
      id: 6,
      value: "対象外",
    },
    {
      id: 8,
      value: "条件期間外",
    },
    {
      id: 9,
      value: "長期不出",
    },
  ],
  toss_up_status_closing: [
    {
      id: 1,
      value: "クロージング-成功",
    },
    {
      id: 7,
      value: "クロージング-成功（未エントリー）",
    },
    {
      id: 10,
      value: "クロージング-成功（他社）",
    },
    {
      id: 2,
      value: "クロージング-失敗",
    },
    {
      id: 3,
      value: "不出",
    },
    {
      id: 4,
      value: "時節",
    },
    {
      id: 5,
      value: "見込み",
    },
    {
      id: 6,
      value: "対象外",
    },
    {
      id: 8,
      value: "条件期間外",
    },
    {
      id: 9,
      value: "長期不出",
    },
  ],
  follow_call_status_xlsx: [
    {
      id: 0,
      value: "フォローコールを行わない",
    },
    {
      id: 1,
      value: "フォローコール未実施",
    },
    {
      id: 2,
      value: "フォローコール完了",
    },
    {
      id: 3,
      value: "不出",
    },
    {
      id: 4,
      value: "時節",
    },
  ],
  follow_call_status: [
    {
      id: 2,
      value: "フォローコール完了",
    },
    {
      id: 3,
      value: "不出",
    },
    {
      id: 4,
      value: "時節",
    },
  ],
  copy_toss_up: [
    {
      id: 0,
      value: "トスアップを複製しない",
    },
    {
      id: 1,
      value: "トスアップを複製する",
    },
  ],
  toss_up_sale_account_name_auth: [
    {
      id: 0,
      value: "他社担当者名を表示しない",
    },
    {
      id: 1,
      value: "他社担当者名を表示する",
    },
  ],
  customer_list_id_flg: [
    {
      id: 0,
      value: "使用しない",
    },
    {
      id: 1,
      value: "グループ1",
    },
    {
      id: 2,
      value: "グループ2",
    },
    {
      id: 3,
      value: "グループ3",
    },
    {
      id: 4,
      value: "グループ4",
    },
    {
      id: 5,
      value: "グループ5",
    },
    {
      id: 6,
      value: "グループ6",
    },
    {
      id: 7,
      value: "グループ7",
    },
    {
      id: 8,
      value: "グループ8",
    },
    {
      id: 9,
      value: "グループ9",
    },
    {
      id: 10,
      value: "グループ10",
    },
  ],
  back_payment_time: [
    {
      id: 0,
      value: "開通日の月末までに解約",
    },
    {
      id: 1,
      value: "開通日の1か月後月末までに解約",
    },
    {
      id: 2,
      value: "開通日の2か月後月末までに解約",
    },
    {
      id: 3,
      value: "開通日の3か月後月末までに解約",
    },
    {
      id: 4,
      value: "開通日の4か月後月末までに解約",
    },
    {
      id: 5,
      value: "開通日の5か月後月末までに解約",
    },
    {
      id: 6,
      value: "開通日の6か月後月末までに解約",
    },
    {
      id: 7,
      value: "開通日の7か月後月末までに解約",
    },
    {
      id: 8,
      value: "開通日の8か月後月末までに解約",
    },
    {
      id: 9,
      value: "開通日の9か月後月末までに解約",
    },
    {
      id: 10,
      value: "開通日の10か月後月末までに解約",
    },
    {
      id: 11,
      value: "開通日の11か月後月末までに解約",
    },
    {
      id: 12,
      value: "開通日の12か月後月末までに解約",
    },
  ],

  advance_payment_high_rank_company: [
    {
      id: 0,
      value: "サービスの支払い開始時期に従う",
    },
    {
      id: 1,
      value: "開通日の月末に入金",
    },
    {
      id: 2,
      value: "開通日の1か月後末に入金",
    },
    {
      id: 3,
      value: "開通日の2か月後末に入金",
    },
    {
      id: 4,
      value: "開通日の3か月後末に入金",
    },
    {
      id: 5,
      value: "開通日の4か月後末に入金",
    },
    {
      id: 6,
      value: "開通日の5か月後末に入金",
    },
    {
      id: 7,
      value: "開通日の6か月後末に入金",
    },
    {
      id: 8,
      value: "開通日の7か月後末に入金",
    },
    {
      id: 9,
      value: "開通日の8か月後末に入金",
    },
    {
      id: 10,
      value: "開通日の9か月後末に入金",
    },
    {
      id: 11,
      value: "開通日の10か月後末に入金",
    },
    {
      id: 12,
      value: "開通日の11か月後末に入金",
    },
    {
      id: 13,
      value: "開通日の12か月後末に入金",
    },
  ],
  advance_payment_sale_company: [
    {
      id: 0,
      value: "サービスの支払い開始時期に従う",
    },
    {
      id: 1,
      value: "開通日の月末に振込",
    },
    {
      id: 2,
      value: "開通日の1か月後末に振込",
    },
    {
      id: 3,
      value: "開通日の2か月後末に振込",
    },
    {
      id: 4,
      value: "開通日の3か月後末に振込",
    },
    {
      id: 5,
      value: "開通日の4か月後末に振込",
    },
    {
      id: 6,
      value: "開通日の5か月後末に振込",
    },
    {
      id: 7,
      value: "開通日の6か月後末に振込",
    },
    {
      id: 8,
      value: "開通日の7か月後末に振込",
    },
    {
      id: 9,
      value: "開通日の8か月後末に振込",
    },
    {
      id: 10,
      value: "開通日の9か月後末に振込",
    },
    {
      id: 11,
      value: "開通日の10か月後末に振込",
    },
    {
      id: 12,
      value: "開通日の11か月後末に振込",
    },
    {
      id: 13,
      value: "開通日の12か月後末に振込",
    },
  ],

  advance_back_payment_sale_company: [
    {
      id: 0,
      value: "解約日の月末に請求",
    },
    {
      id: 1,
      value: "解約日の1か月後末に請求",
    },
    {
      id: 2,
      value: "解約日の2か月後末に請求",
    },
    {
      id: 3,
      value: "解約日の3か月後末に請求",
    },
    {
      id: 4,
      value: "解約日の4か月後末に請求",
    },
    {
      id: 5,
      value: "解約日の5か月後末に請求",
    },
    {
      id: 6,
      value: "解約日の6か月後末に請求",
    },
  ],
  advance_back_payment_high_rank_company: [
    {
      id: 0,
      value: "解約日の月末に請求",
    },
    {
      id: 1,
      value: "解約日の1か月後末に請求",
    },
    {
      id: 2,
      value: "解約日の2か月後末に請求",
    },
    {
      id: 3,
      value: "解約日の3か月後末に請求",
    },
    {
      id: 4,
      value: "解約日の4か月後末に請求",
    },
    {
      id: 5,
      value: "解約日の5か月後末に請求",
    },
    {
      id: 6,
      value: "解約日の6か月後末に請求",
    },
  ],
  site_color: [
    {
      id: 0,
      value: "緑",
    },
  ],
  site_layout: [
    {
      id: 0,
      value: "デフォルト",
    },
  ],
  site_pdf_agree: [
    {
      id: 0,
      value: "同意あり",
    },
    {
      id: 1,
      value: "同意なし",
    },
  ],
  site_pdf_footer: [
    {
      id: 0,
      value: "表示",
    },
    {
      id: 1,
      value: "非表示",
    },
  ],
  outside_cancell_form: [
    {
      id: 0,
      value: "解約フォームを作成しない",
    },
    {
      id: 1,
      value: "解約フォームを作成する",
    },
  ],
  entry_sale_company_group: [
    {
      id: 0,
      value: "指定しない",
    },
    {
      id: 1,
      value: "指定する",
    },
  ],
  trial_period_months: [
    {
      id: 0,
      value: "特に表示なし（登録月から課金開始）",
    },
    {
      id: 1,
      value: "１か月間無料",
    },
    {
      id: 2,
      value: "２か月間無料",
    },
    {
      id: 3,
      value: "３か月間無料",
    },
    {
      id: 4,
      value: "４か月間無料",
    },
    {
      id: 5,
      value: "５か月間無料",
    },
    {
      id: 6,
      value: "６か月間無料",
    },
  ],
  outside_sms_type: [
    {
      id: 0,
      value: "ショートメッセージ",
    },
    {
      id: 1,
      value: "メール",
    },
  ],
  cancell_sms_type: [
    {
      id: 0,
      value: "ショートメッセージ",
    },
    {
      id: 1,
      value: "メール",
    },
  ],
  outside_entry_form_service_type: [
    {
      id: 0,
      value: "プルダウン",
    },
    {
      id: 1,
      value: "チェックボックス",
    },
  ],
  outside_form_display: [
    {
      id: 0,
      value: "表示する",
    },
    {
      id: 1,
      value: "表示しない",
    },
  ],
  service_required_optional_pull_down: [
    {
      id: 0,
      value: "任意",
    },
    {
      id: 1,
      value: "必須",
    },
  ],
  service_required_optional_check_box: [
    {
      id: 0,
      value: "任意",
    },
    {
      id: 1,
      value: "必須",
    },
  ],
  screen_name: [
    {
      id: 0,
      value: "トスアップ管理",
    },
    {
      id: 1,
      value: "エントリー管理",
    },
  ],
  screen_column_auth: [
    {
      id: 0,
      value: "表示制限なし",
    },
    {
      id: 1,
      value: "マスター・スタッフアカウントのみ",
    },
  ],
  login_sale_company: [
    {
      id: 0,
      value: "全パートナー",
    },
    {
      id: 1,
      value: "指定したログインパートナーのみ",
    },
  ],
  login_collaborate_company: [
    {
      id: 0,
      value: "自社にのみ項目を登録する",
    },
    {
      id: 1,
      value: "協業パートナーにも同一項目を登録する",
    },
  ],
  screen_column_type: [
    {
      id: 0,
      value: "フリー記入",
    },
    {
      id: 1,
      value: "プルダウン",
    },
    {
      id: 2,
      value: "チェックボックス",
    },
    {
      id: 3,
      value: "日付",
    },
  ],
};

// 本番環境判定（AIナビゲーション非表示制御用）
export const isProductionEnv: boolean = (config.ENVIRONMENT || "") === "Pro";
